import React from 'react'
import { Link } from 'gatsby'

// import Image from './Image'
import './SponsorSection.css'

export const SponsorSection = ({ sponsors, className = '' }) => {
  return (
    <section className="section">
      <div className="container">
        <div className="SponsorSection">
          <h2>Our Partners</h2>
          <div className="SponsorSection--Grid">
            {sponsors &&
              sponsors.map((sponsor, index) => (
                <a
                  href={sponsor.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={index}
                  className={`SponsorCard ${className}`}
                >
                  <div className="SponsorCard--Image relative">
                    <img src={sponsor.featuredImage} alt={sponsor.title} />
                    {/* <Image
                      background
                      src={sponsor.featuredImage}
                      alt={sponsor.title}
                    /> */}
                  </div>
                </a>
              ))}
          </div>
          <div className="taCenter">
            <Link to="/contact/">
              <div className="Button">Become A Partner</div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SponsorSection
